// useRubriques.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import RubriqueService from "@/integrations/service/rubrique.service";

export const useRubriques = () => {
  return useQuery({
    queryKey: queryKeys.rubriques,
    queryFn: RubriqueService.getAll,
  });
};

export const useCreateRubrique = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: RubriqueService.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.rubriques });
    },
  });
};

export const useUpdateRubrique = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: any) =>
      RubriqueService.update(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.rubriques });
    },
  });
};

export const useDeleteRubrique = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: RubriqueService.delete,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.rubriques });
    },
  });
};
